import { Outlet, useLocation, useNavigate } from "react-router-dom"
import styled from "styled-components"

import { ReactComponent as BackIcon } from "assets/svg/icon-arrow-left.svg"

import { ContentWrapper } from "components/common/ContentWrapper"
import MessageTemplatesList from "components/common/MessageTemplatesList"
import { ButtonNew } from "components/form/ButtonNew"

import styles from "../../../assets/scss/index.module.scss"
import { MessageTemplateProvider, useMessageTemplateContext } from "./MessageTemplateContext"

const BackButton = styled(ButtonNew)`
  margin-top: -48px;
  position: relative;
`

const StyledContentWrapper = styled.div`
  background: $colorWhite;
  overflow-x: scroll;
  min-height: calc(100vh - 190px);
  display: flex;
  justify-content: space-between;

  @media only screen and (max-width: 1200px) {
    flex-wrap: wrap;
  }
`

const SectionWrapper = styled.div`
  width: calc(50% - 12px);
  max-height: 550px;

  @media only screen and (max-width: 1200px) {
    width: 100%;

    &:first-child {
      margin-bottom: 24px;
    }
  }
`

const getTitleFromPath = (pathname: string): string => {
  if (pathname.includes("/edit-template")) {
    return "Edit message template"
  }
  if (pathname.includes("/add-template")) {
    return "Add message template"
  }
  return "Create message template"
}

const MessageTemplateContainerLayoutInner = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { onCreateTemplate, isLoading } = useMessageTemplateContext()

  const title = getTitleFromPath(location.pathname)

  return (
    <ContentWrapper title={title}>
      <nav className={styles.tableNavWrapper}>
        <div></div>
        <BackButton onClick={() => navigate("/messages2/center")} color="greyBordered">
          <BackIcon />
          Back
        </BackButton>
      </nav>
      <StyledContentWrapper>
        <SectionWrapper>
          <Outlet />
        </SectionWrapper>
        <SectionWrapper>
          <MessageTemplatesList onCreateTemplate={onCreateTemplate} isLoading={isLoading} />
        </SectionWrapper>
      </StyledContentWrapper>
    </ContentWrapper>
  )
}

const MessageTemplateContainerLayout = () => {
  return (
    <MessageTemplateProvider>
      <MessageTemplateContainerLayoutInner />
    </MessageTemplateProvider>
  )
}

export default MessageTemplateContainerLayout
